module.exports = __webpack_public_path__ + "img/ico-check.68e5c3c0.svg";